import React from 'react';

const HouseholdEligibilityGroup = ({ group }) => {
    const {
        members,
        statuses
    } = group;

    return (
        <div className="grid-row household-eligibility-group">
            <ul className="tablet:grid-col-6 padding-x-2 household-eligibility-group__members">
                {
                    members.map(member => (
                        <li key={member.id}>
                            <span>{member.name}</span>
                            <ul className="household-eligibility-group__indicators text-green">
                                {member.indicators.map((indicator, ind) => (
                                    <li key={ind} className="household-eligibility-group__indicators_item">
                                        {indicator}
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))
                }
            </ul>
            <ul className="tablet:grid-col-6 padding-x-2 household-eligibility-group__statuses">
                {statuses.map((status, index) => status && (
                    <li key={index}>
                        {status}
                    </li>
                )
                )}
            </ul>
        </div>
    );
};

const HouseholdEligibilityGroups = ({ groups }) => {

    return (
        <div className="tablet:grid-col-9">
            {
                groups.map((group, index) => {
                    if (group.members && group.members.length > 0) {
                        return (
                            <HouseholdEligibilityGroup group={group} key={index}/>
                        );
                    }
                })
            }
        </div>
    );
};

export default HouseholdEligibilityGroups;